import FormattedList from 'I18n/components/FormattedList';
import FormattedMessage from 'I18n/components/FormattedMessage';
import unescapedText from 'I18n/utils/unescapedText';
import { View } from 'foundations-components/components/View';
import { Link } from 'foundations-components/transitional/components/Link';
import { DescriptionList } from 'foundations-components/transitional/components/DescriptionList';
import { Tag } from 'foundations-components/transitional/components/Tag';
import { formatInstalls } from 'marketplace-ui-common/utils/installs';
import { Fragment, useCallback, useMemo } from 'react';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import { getCategoryV2Url, getFormattedUrl } from '../../../../utils/urls';

// @ts-expect-error untyped dependency
import FilterTag from '../FilterTag';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Section = ({
  children,
  label
}) => /*#__PURE__*/_jsxs(Fragment, {
  children: [/*#__PURE__*/_jsx("dt", {
    children: label
  }), /*#__PURE__*/_jsx("dd", {
    children: children
  })]
});
export function AppDetails({
  appLanguages,
  categoryV2,
  companyName,
  companyUrl,
  homemade,
  installs,
  isPreview,
  onTrackInteraction
}) {
  const trackInteraction = useCallback((action, value) => onTrackInteraction(action, {
    section: 'details',
    value
  }), [onTrackInteraction]);
  const renderedCategoryV2Section = useMemo(() => {
    return categoryV2 && categoryV2.length > 0 ? /*#__PURE__*/_jsx(Section, {
      label: unescapedText('appMarketplace.detail.overview.sidebar.details.categoryV2Label'),
      children: /*#__PURE__*/_jsx(View, {
        marginBlockStart: "100",
        children: categoryV2.map((categoryItem, index) => /*#__PURE__*/_jsx(View, {
          display: "inline-block",
          marginInlineEnd: "200",
          children: /*#__PURE__*/_jsx(UIRouterLink, {
            disabled: isPreview,
            to: getCategoryV2Url(categoryItem),
            children: /*#__PURE__*/_jsx(FilterTag, {
              children: /*#__PURE__*/_jsx(Tag, {
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: `marketplace-ui-apps-core.groupTags.category.${categoryItem}`
                })
              })
            })
          })
        }, index))
      })
    }) : null;
  }, [categoryV2, isPreview]);
  const renderedLanguagesSection = useMemo(() => {
    if (appLanguages.length === 0 || appLanguages.some(lang => !lang)) {
      return null;
    }
    return /*#__PURE__*/_jsx(Section, {
      label: homemade ? unescapedText('appMarketplace.detail.overview.sidebar.details.homemadeAppLanguagesLabel') : unescapedText('appMarketplace.detail.overview.sidebar.details.appLanguagesLabel'),
      children: /*#__PURE__*/_jsx(View, {
        marginBlockStart: "100",
        children: /*#__PURE__*/_jsx(FormattedList, {
          children: appLanguages.map(languageCode => [languageCode, `SharedI18nStrings.languageNames.${languageCode}`]).sort(([__, languageNameI18nKey], [___, nextLanguageNameI18nKey]) => unescapedText(languageNameI18nKey).localeCompare(unescapedText(nextLanguageNameI18nKey))).map(([languageCode, languageNameI18nKey]) => /*#__PURE__*/_jsx(FormattedMessage, {
            message: languageNameI18nKey
          }, languageCode))
        })
      })
    });
  }, [appLanguages, homemade]);
  const renderedCompanyName = useMemo(() => {
    return companyUrl ? /*#__PURE__*/_jsx(Link, {
      external: true,
      href: getFormattedUrl(companyUrl) || undefined,
      onClick: () => trackInteraction('click provider link'),
      children: companyName
    }) : companyName;
  }, [companyName, companyUrl, trackInteraction]);
  const renderedInstallsSection = useMemo(() => {
    return /*#__PURE__*/_jsx(Section, {
      label: unescapedText('appMarketplace.detail.overview.sidebar.details.installsLabel'),
      children: formatInstalls(installs)
    });
  }, [installs]);
  return /*#__PURE__*/_jsxs(DescriptionList, {
    "data-test-id": "app-details",
    children: [/*#__PURE__*/_jsx(Section, {
      label: unescapedText('appMarketplace.detail.overview.sidebar.details.providerLabel'),
      children: renderedCompanyName
    }), renderedInstallsSection, renderedCategoryV2Section, renderedLanguagesSection]
  });
}